import { render, staticRenderFns } from "./WhenQuestionWithNumberInput.vue?vue&type=template&id=55bca59d&scoped=true&"
import script from "./WhenQuestionWithNumberInput.vue?vue&type=script&lang=js&"
export * from "./WhenQuestionWithNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./WhenQuestionWithNumberInput.vue?vue&type=style&index=0&id=55bca59d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bca59d",
  null
  
)

export default component.exports